import { AbstractControl, ValidationErrors } from '@angular/forms';

// Shared by Add / Edit Agency and the Add New agency pop-up on the client form.

export const AGENCY_TYPES = ['Real Estate Office', 'Title/Escrow', 'Other'];

// The mockup's new contact / agency forms start on CA, where the inspection companies are.
export const DEFAULT_STATE = 'CA';

/**
 * An agency is identified by its office name or, failing that, its title (mockup Add Agency).
 * The API applies the same rule (CompanyController, required_without).
 */
export function nameOrTitle(group: AbstractControl): ValidationErrors | null {
  const name = (group.get('company_name').value || '').trim();
  const title = (group.get('company_title').value || '').trim();
  return name || title ? null : { nameOrTitle: true };
}

/** What the app calls an agency: its title when it has one, else its office name. */
export function agencyName(company: { company_name?: string, company_title?: string }): string {
  return company ? ((company.company_title || '').trim() || (company.company_name || '').trim()) : '';
}
